var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"formContainer"},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('templates')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }